import { render, staticRenderFns } from "./InviteHome.vue?vue&type=template&id=2b1ef4cc&"
import script from "./InviteHome.vue?vue&type=script&lang=js&"
export * from "./InviteHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports